
import React, { Component } from "react";
import styled from "styled-components";
import { Wrapper, Button } from 'react-aria-menubutton';
import BubbleMenu from '../../BubbleMenu';

const Container = styled.li`
    text-align: center;
    display: inline-block;
    width: auto;
    height: 80px;
    margin-left: 18px;
    text-align: center;
    line-height: 16px;

    > div {
        position: relative;
    }

    span[role=button] {
        display: block;
        border: none;
        background-repeat: no-repeat;
        background-size: 42px 42px;
        background-position: center top;
        background-color: white;
        max-width: 64px;
        padding: 47px 0 0 0;

        font-family: Lato-Regular;
        font-size: 12px;
        color: #666666;
        text-decoration: none;
        word-wrap: break-word;
        cursor: pointer;
    }
`

class ActionButton extends Component {

    handleSelection(value) {
        if (value === 'destroy') {
            this.setState({ noMenu: true });
        } else {
            this.setState({ selected: value });
            if(this.props.onChange){
                this.props.onChange(value)
            }
        }
    }

    onButtonClick = () => {
        if(this.props.onButtonClick){
            this.props.onButtonClick()
        }
    }

    onKeyDown = (event) => {
        switch (event.keyCode) {
            case 32: // SPACE
            case 13: // RETURN
                this.props.onButtonClick();
                event.stopPropagation();
                event.preventDefault();
                break;

            default:
                break;
        }
    }

    render() {
        return (
            <Container className={this.props.className}>
                <Wrapper onSelection={this.handleSelection.bind(this)}>
                    {!this.props.options &&
                        <div><span onClick={this.onButtonClick} onKeyDown={this.onKeyDown} role="button" tabIndex="0" aria-haspopup="true">{this.props.title}</span></div>
                    }
                    {this.props.options &&
                        <Button>{this.props.title}</Button>
                    }
                    {this.props.options &&
                        <BubbleMenu arrow="left" options={this.props.options} selectedValue={this.props.selectedValue}/>
                    }
                </Wrapper>
            </Container>
        );
    }
}

export default ActionButton;